import React from "react";
import {
  Apps32,
  Facebook32,
  Instagram32,
  Linkedin32,
  Twitter32,
  Youtube32,
} from "src/assets/mapfre-icons-components";
import packageInfo from "../../../../package.json";
import { Button } from "../button";

const FOOTER_DATA = [
  {
    icon: <Apps32 />,
    href: "https://www.mapfre.com.br/atendimento/aplicativo/aplicativo-mapfre/",
    title: "Nossos apps",
  },
  {
    icon: <Instagram32 />,
    href: "https://www.instagram.com/mapfrebr/?hl=pt-br",
    title: "Siga em Instagram",
  },
  {
    icon: <Facebook32 />,
    href: "https://www.facebook.com/MAPFREbr",
    title: "Siga em Facebook",
  },
  {
    icon: <Twitter32 />,
    href: "https://twitter.com/mapfre_br",
    title: "Siga em X",
  },
  {
    icon: <Youtube32 />,
    href: "https://www.youtube.com/MAPFREBrasil",
    title: "Siga em Youtube",
  },
  {
    icon: <Linkedin32 />,
    href: "https://www.linkedin.com/company/mapfre/",
    title: "Siga em LinkedIn",
  },
];

const Footer: React.FC = () => {
  return (
    <footer className="text-secondary-2 border-secondary-4 relative mt-14 flex flex-col items-center justify-center gap-4 border-t py-6 lg:flex-row lg:justify-between">
      <p className="caption-m-lower col-span-6">
        {`Mapfre © ${new Date().getFullYear()} Todos los derechos reservados`}
      </p>
      <div className="flex gap-x-2">
        {FOOTER_DATA.map((item) => (
          <Button variant="ghost" size="icon" asChild key={item.title}>
            <a
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              title={item.title}
            >
              {item.icon}
            </a>
          </Button>
        ))}
      </div>
      <span className="absolute right-0 bottom-0.5 left-0 text-center text-[10px] text-gray-400">
        v{packageInfo.version}
      </span>
    </footer>
  );
};

export default Footer;
